import React, {useCallback, memo, useMemo} from 'react';
import styles from './style.module.scss';
import {Text} from '@priority-software/priority-style-react';
import {texts} from '../../../../texts';
import {SelectControl} from '../AutomationRuleSelect/SelectControl';
import {AlertFields} from '../../../../enums';
import {SingleValueControl} from '../AutomationRuleCondition/SingleValueControl';
import {AutomationChoose} from '../../../../reducer/model';
import {IAlert} from '../../../../actions/proto';
import {priority} from '@priority-software/priority-proto-api/lib';

type Props = {
    fieldsOptions: AutomationChoose[];
    setFieldValue?: number;
    onRuleUpdate: (data: Partial<IAlert>) => void;
    autoFillValue?: string;
};

type IAlertChoose = priority.netitems.form.IAlertChoose;

export const AutofillActionContent = memo((props: Props) => {
    const {fieldsOptions, setFieldValue, autoFillValue, onRuleUpdate} = props;

    const valueFieldsOptions = useMemo(() => {
        return fieldsOptions.filter(
            item => !(item.data as priority.netitems.form.IAlertChoose).ReadOnly
        );
    }, [fieldsOptions]);

    const targetFieldOption = useMemo(
        () => valueFieldsOptions.find(option => option.value === setFieldValue),
        [valueFieldsOptions, setFieldValue]
    );

    const handleAutofillSetField = useCallback(
        (option: AutomationChoose) => {
            if (option.value !== setFieldValue) {
                onRuleUpdate({
                    [AlertFields.RecipientField]: Number(option.value),
                    [AlertFields.RecipientMail]: undefined
                });
            }
        },
        [onRuleUpdate, setFieldValue]
    );

    const handleAutofillValue = useCallback(
        (value: string) => {
            onRuleUpdate({[AlertFields.RecipientMail]: [value]});
        },
        [onRuleUpdate]
    );

    return (
        <div className={styles.autofillActionContent}>
            <div className={styles.row}>
                <div className={styles.rowItem}>
                    <Text
                        tag="label"
                        textColor="primary-700"
                        skin="paragraph-2"
                        componentClasses="pui-label-required"
                    >
                        {texts.autofill_condition_set}
                    </Text>

                    <SelectControl
                        onChange={handleAutofillSetField}
                        options={valueFieldsOptions}
                        defaultValue={setFieldValue || undefined}
                        name={AlertFields.RecipientField}
                    />
                </div>

                <div className={styles.rowItem}>
                    <Text tag="label" textColor="primary-700" skin="paragraph-2">
                        {texts.autofill_condition_as}
                    </Text>

                    <SingleValueControl
                        openingSide="leftSide"
                        key={`${setFieldValue}`}
                        relatedField={setFieldValue}
                        onChange={handleAutofillValue}
                        value={autoFillValue}
                        placeholder={''}
                        zoom={(targetFieldOption?.data as IAlertChoose)?.Zoom}
                        name={AlertFields.RecipientMail} // Please, no judge, Backend team quirks
                    />
                </div>
            </div>
        </div>
    );
});
